import {getOrganizationAutosuggest} from '@account/api';
import {useQuery} from '@tanstack/react-query';

export const useOrgAutosuggest = (
  {limit = 8, search = '', excludeSuborgs = false},
  options = {}
) => {
  const params = {limit, search, excludeSuborgs};

  return useQuery(['orgs', params], () => getOrganizationAutosuggest(params), {
    ...options,
  });
};
